import { defineModule } from '@core/modules';
import { ModulePath, ModuleTitle } from '@common/types';
import DocumentsTrash from './containers';

export default defineModule({
  title: ModuleTitle.DocumentsTrash,
  path: ModulePath.DocumentsTrash,
  component: DocumentsTrash
});
